import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import ShareLinkEditor from './ShareLinkEditor.jsx';
import { useIsMobile } from '../lib/useIsMobile.js';

// "Shareable link" straight off a dashboard's ⋯ menu — the same sheet Settings
// uses, with the report already decided and the filters you're looking at frozen
// in. Sharing a report you're reading shouldn't mean going to Settings, choosing
// the report again from a list and re-picking the event.
//
// A bottom sheet on phones, a centred dialog on desktop; Escape closes, and the
// body doesn't scroll behind it.
export default function ShareLinkModal({ scope, entityId, target, filterValues, onClose }) {
  const isMobile = useIsMobile();

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => { document.body.style.overflow = prev; window.removeEventListener('keydown', onKey); };
  }, [onClose]);

  return createPortal(
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 500, background: 'rgba(0,0,0,0.45)',
        display: 'flex', alignItems: isMobile ? 'flex-end' : 'center', justifyContent: 'center',
        padding: isMobile ? 0 : 20,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="modal-in"
        style={{
          background: 'var(--bg)', color: 'var(--text)',
          borderRadius: isMobile ? '16px 16px 0 0' : 16,
          // Wide enough for the preview's 24-column grid to be worth looking at;
          // the form inside caps itself at 620, so this only helps the preview.
          width: isMobile ? '100%' : 'min(940px, 100%)',
          maxHeight: isMobile ? '92dvh' : '88vh',
          overflowY: 'auto',
          padding: isMobile ? '18px 16px calc(18px + env(safe-area-inset-bottom))' : 22,
          boxShadow: 'var(--shadow-pop)',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
          <span style={{ flex: 1 }} />
          <button onClick={onClose} aria-label="Close" style={{ border: 'none', background: 'rgba(128,128,128,0.12)', color: 'var(--muted-2)', borderRadius: 980, width: 32, height: 32, fontSize: 14, cursor: 'pointer' }}>✕</button>
        </div>
        <ShareLinkEditor
          scope={scope}
          entityId={entityId}
          fixedTarget={target}
          filterValues={filterValues}
          onClose={() => onClose()}
        />
      </div>
    </div>,
    document.body,
  );
}
